<script setup lang="ts">
import type { ImageDestination } from "@/composables/useContainerImageDestinationPrompt"
import { ICON } from "@/lib/icons"

defineProps<{
  open: boolean
  fileName: string
  previewUrl: string
}>()

const emit = defineEmits<{
  choose: [destination: ImageDestination]
}>()
</script>

<template>
  <UModal :open="open" :close="false" :dismissible="false" title="Where does this photo belong?">
    <template #body>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <img
            :src="previewUrl"
            :alt="fileName"
            class="bg-muted aspect-video w-full rounded-lg object-contain"
          />
          <p class="text-muted truncate text-xs">{{ fileName }}</p>
        </div>

        <p class="text-sm">Is this a photo of the container itself, or a new item inside it?</p>

        <div class="flex flex-col gap-2">
          <UButton
            data-destination="container"
            label="Container itself"
            :icon="ICON.container"
            color="neutral"
            variant="outline"
            block
            @click="emit('choose', 'container')"
          />
          <UButton
            data-destination="child"
            label="New item inside"
            :icon="ICON.item"
            color="neutral"
            variant="outline"
            block
            @click="emit('choose', 'child')"
          />
        </div>
      </div>
    </template>
  </UModal>
</template>
